import React from 'react';
import { Link } from 'react-router-dom';

const OrderConfirmedPage = () => (
  <div className="bg-white min-h-screen">
    <section className="py-12 px-4 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
      <h1 className="text-3xl md:text-5xl font-medium text-white text-center">Order Placed!</h1>
    </section>
    <section className="py-16 px-4 md:px-[140px] text-center">
      <div className="max-w-lg mx-auto">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl">✓</span>
        </div>
        <h2 className="text-2xl font-bold text-[#272727] mb-4">Thank you for your order!</h2>
        <p className="text-[#272727]/70 mb-8">We'll send you a confirmation email shortly.</p>
        <Link to="/products">
          <button className="bg-[#8e0707] hover:bg-[#6b0505] text-white px-8 py-3 rounded">
            Continue Shopping
          </button>
        </Link>
      </div>
    </section>
  </div>
);

export default OrderConfirmedPage;
